import {DELETE_ERROR_SUCCESS} from "../../../reducers/errorsReducer";


export const deleteErrorSuccess = (errorIds) =>{
    return {
        type: DELETE_ERROR_SUCCESS,
        payload: {errorIds}
    }
}